import { graphql, useStaticQuery } from 'gatsby';

export const homePageQuery = () => {
  const data = useStaticQuery(graphql`
    query {
      pageContentJson {
        homePage {
          topSection {
            content {
              headline
              description
              button {
                text
                link
              }
              cta
            }
            styles {
              color
              descriptionColor
              background
              buttonColor
              buttonTextColor
            }
          }
          blockquote {
            headline
            quote
            name
            title
          }
          carousel {
            items {
              id
              image
              caption
            }
          }
          descriptionSection {
            content {
              headline
              photoCard {
                headline
                description
              }
              cards {
                title
                icon
                description
              }
            }
            styles {
              titleBackgroundColor
            }
          }
          actionBarTop {
            color
            headline
            description
            buttonText
            link
          }
          actionBarMiddle {
            color
            headline
            description
            buttonText
            link
          }
          actionBarBottom {
            color
            headline
            description
            buttonText
            link
          }
        }
      }
    }
  `);
  const homePageContent = data.pageContentJson.homePage;
  const homeTopContent = homePageContent.topSection.content;
  const homeTopStyles = homePageContent.topSection.styles;
  const homeDescriptionContent = homePageContent.descriptionSection.content;
  const homeDescriptionStyles = homePageContent.descriptionSection.styles;
  const blockQuote = homePageContent.blockquote;
  const carouselItems = homePageContent.carousel.items;
  const actionBarTopContent = homePageContent.actionBarTop;
  const actionBarMiddleContent = homePageContent.actionBarMiddle;
  const actionBarBottomContent = homePageContent.actionBarBottom;
  return {
    homeTopContent,
    homeTopStyles,
    homeDescriptionContent,
    homeDescriptionStyles,
    blockQuote,
    carouselItems,
    actionBarTopContent,
    actionBarMiddleContent,
    actionBarBottomContent,
  };
};
